import { useEffect, useState } from "react";
import useHttpFetch from "./useHttpFetch";
import fieldAccessDestructor from "../utils/accessUtils/fieldAccessFinder";
import storeFieldAccessInIndexedDB from "../utils/cache/FieldConfig/storeFieldAccessInIndexedDB";
import readFieldAccessFromIndexedDB from "../utils/cache/FieldConfig/readFieldAccessFromIndexedDB";

const useFieldAccess = (
  entityNames,
  information,
  port,
  currentState = "unset",
  keysToRemoveForValidation = [],
) => {
  const [fieldAccesses, setFieldAccesses] = useState({});
  const [getFieldsUrl, setGetFieldsUrl] = useState("");
  // const [updateFieldsUrl, setUpdateFieldsUrl] = useState("");
  const { error, sendRequest } = useHttpFetch(true);
  const [fieldAccessesAreLoading, setFieldAccessesAreLoading] = useState(true);
  const [fieldAccessValidations, setFieldAccessValidations] = useState(null);

  useEffect(() => {
    const fieldAccessGetReq = async (entityNames) => {
      const verifyReqOptions = {
        method: "GET",
        url: `FieldConfig/${entityNames}`,
        noMiddleUrl: true,
        port,
      };

      const fieldAccessRes = await sendRequest(verifyReqOptions);
      if (fieldAccessRes.resIsOk) {
        const preferedResponse = Object.keys(fieldAccessRes?.response).reduce((acc, key) => {
          // Map through each array and replace dots in fieldName
          acc[key.replace(/_/g, "")] = fieldAccessRes?.response[key].map((item) => ({
            ...item,
            fieldName: item.fieldName.replace(/_/g, "").replace(/\./g, "_"), // Replace all dots with underscores or any other character
          }));
          return acc;
        }, {});
        const preferedIndexedDBResponse = Object.keys(fieldAccessRes?.response).reduce((acc, key) => {
          // Map through each array and replace dots in fieldName
          acc[key] = fieldAccessRes?.response[key].map((item) => ({
            ...item,
            fieldName: item.fieldName.replace(/_/g, "").replace(/\./g, "_"), // Replace all dots with underscores or any other character
          }));
          return acc;
        }, {});

        await storeFieldAccessInIndexedDB(preferedIndexedDBResponse);
        return preferedResponse;
      } else {
        return {};
      }
    };

    const handleAccessStates = async () => {
      setFieldAccessesAreLoading(true);
      let responses = {};
      // const fetchedFieldAccesses = await fieldAccessGetReq(entityNames.join(","));
      // if (fetchedFieldAccesses) responses = { ...fetchedFieldAccesses };

      let fetchedFieldAccesses = {};
      const { foundedFieldConfigs, notFoundedEntityNames } =
        await readFieldAccessFromIndexedDB(entityNames);
      if (notFoundedEntityNames?.length > 0) {
        fetchedFieldAccesses = await fieldAccessGetReq(notFoundedEntityNames.join(","));
      }
      // console.log("foundedFieldConfigs : ", foundedFieldConfigs);
      // console.log("fetchedFieldAccesses : ", fetchedFieldAccesses);
      // console.log("notFoundedEntityNames : ", notFoundedEntityNames);
      responses = { ...foundedFieldConfigs, ...fetchedFieldAccesses };

      if (Object.values(responses).every((value) => Array.isArray(value) && value.length === 0)) {
        setFieldAccesses("noFieldsAvailable");
      } else {
        setFieldAccesses(responses);

        // setFieldAccessValidations *****
        const clonedFieldAccessGrants = JSON.parse(JSON.stringify(responses));
        const validations = Object.entries(clonedFieldAccessGrants).reduce((acc, [key, value]) => {
          if (!keysToRemoveForValidation.includes(key)) {
            const filteredValue = value?.filter(
              (each) =>
                each.selectAccess &&
                (each.validationType || each.isMandatory || each.inWhichStateOrderItBecomesNecessary),
            );
            if (filteredValue.length) {
              acc[key] = filteredValue;
            }
          }
          return acc;
        }, {});
        setFieldAccessValidations(validations);
      }

      let urlFieldAccessArr = [];
      for (let each of information) {
        let hasAccessesTo = [];
        for (let which of each.ids) {
          // console.log("which", which);
          // console.log("responses", responses);
          const accessKeyOfObject = which.split("_")[0];
          let hasAccessTo = fieldAccessDestructor(
            responses?.[accessKeyOfObject],
            which,
            currentState,
          )[0];
          hasAccessesTo.push(hasAccessTo);
          // console.log("hasAccessTo", hasAccessTo);
        }
        // console.log(hasAccessesTo);
        let finalDecision = hasAccessesTo.includes(false);
        if (!finalDecision) {
          urlFieldAccessArr.push(each.value);
        }
      }
      const neededFieldsUrl = urlFieldAccessArr.join(",");
      setGetFieldsUrl(neededFieldsUrl);

      // let putFieldAccessArr = []; for (let each of information) { let hasAccessesTo = []; for (let which of each.ids) { const accessKeyOfObject = which.split("_")[0]; let hasAccessTo = fieldAccessDestructor( responses?.[accessKeyOfObject], which, currentState, )[1]; hasAccessesTo.push(hasAccessTo); } let finalDecision = hasAccessesTo.includes(false); if (!finalDecision) { let properPutFieldValue = each.value.includes(".") ? each.value.substring(0, each.value.indexOf(".")) : each.value; putFieldAccessArr.push(properPutFieldValue); } } const uniquePutFieldsArray = [...new Set(putFieldAccessArr)]; const neededPutFieldsArray = uniquePutFieldsArray.join(","); setUpdateFieldsUrl(neededPutFieldsArray);
      setFieldAccessesAreLoading(false);
    };

    handleAccessStates();
  }, []);

  // useEffect(() => { if (currentState) if ( !Object.values(fieldAccesses).every((value) => Array.isArray(value) && value.length === 0) && updateFieldsUrl ) { let putFieldAccessArr = []; for (let each of information) { let hasAccessesTo = []; for (let which of each.ids) { const accessKeyOfObject = which.split("_")[0]; let hasAccessTo = fieldAccessDestructor( fieldAccesses?.[accessKeyOfObject], which, currentState )[1]; hasAccessesTo.push(hasAccessTo); } let finalDecision = hasAccessesTo.includes(false); if (!finalDecision) { let properPutFieldValue = each.value.includes(".") ? each.value.substring(0, each.value.indexOf(".")) : each.value; putFieldAccessArr.push(properPutFieldValue); } } const uniquePutFieldsArray = [...new Set(putFieldAccessArr)]; const neededPutFieldsArray = uniquePutFieldsArray.join(","); setUpdateFieldsUrl(neededPutFieldsArray); } }, [currentState]);

  return {
    fieldAccesses,
    getFieldsUrl,
    // updateFieldsUrl,
    fieldAccessesAreLoading,
    error,
    // setUpdateFieldsUrl,
    setFieldAccesses,
    fieldAccessValidations,
  };
};

export default useFieldAccess;
